import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { ResourceGroup } from "@app/models/rest/resource-group";

@Injectable({
  providedIn: "root"
})
export class ResourceGroupRestService extends HateoasResourceOperation<ResourceGroup> {
  constructor() {
    super(ResourceGroup);
  }
}
